//部门机构列表数据结构修改为联动数据格式
var deptListToCascader = function(list) {
  if (list &&  list.length > 0) {
      return deptListGenChild(list);
  } else {
      return [];
  }
};
var deptListGenChild = function (list) {
  let arr = [];
  list.forEach((item) => {
      let itemObj = {};

      itemObj.label = item.deptName;
      itemObj.value = item.bizId;

      if (item.children && item.children.length > 0) {
          itemObj.children = deptListGenChild(item.children);
      }

      arr.push(itemObj);
  });
  return arr;
};


export default deptListToCascader;


// WEBPACK FOOTER //
// ./src/utils/deptListToCascader.js